import React from "react";

import { Login } from "./Login";
import { LoginCredentialsStep, LoginOTPStep } from "./components";
import { LoginStepsProvider } from "./contexts";

const INITIAL_ITEMS = [
  <LoginCredentialsStep key="LoginCredentialsStep" />,
  <LoginOTPStep key="LoginOTPStep" />,
];

const LoginWrapper = () => {
  return (
    <LoginStepsProvider initialItems={INITIAL_ITEMS}>
      <Login />
    </LoginStepsProvider>
  );
};

export default LoginWrapper;
